var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Api from "../api/api";
var http = new Api();
export default {
    state: {
        // 执行措施
        executeIndex: [],
        // 核心措施
        kernelIndex: {
            // 权威资源
            AuthoritativeResources: {},
            // 财政资源
            FinancialResources: {},
            // 满意度
            Satisfaction: {}
        },
        residueTime: [],
        // 一些取值为布尔的判断
        judgment: {
            showIncident: false // 是否显示执行事件
        },
        // 执行事件
        incedent: {},
        // 核心指标图片名称
        targetImgNameList: [
            { name: '权威资源', path: 'bottle' },
            { name: '财政资源', path: 'possession' },
            { name: '目标人群满意度', path: 'laugh' },
        ],
        // 反馈
        feedback: [],
        executeMeasureData: {},
        // 数据监控----措施
        monitorMeasure: [],
        // 数据监控----事件
        incedentMeasureData: [],
        endState: {},
        // 数据监控----折线图数据
        measure: [],
        departmentList: []
    },
    mutations: {
        // clearStore(state: {kernelIndex: KernelIndex, residueTime: Array<number>} ) {
        //   state.kernelIndex = {
        //     AuthoritativeResources: {},
        //   }
        //   delete state.residueTime
        // },
        /**
         * 初始化执行执行指标
         * @param state
         * @param data
         */
        setExecuteIndex: function (state, data) {
            state.executeIndex = data;
        },
        /**
         * 更新执行指标某个值
         * @param state
         * @param data
         */
        pulExecuteIndexItem: function (state, data) {
            var element = state.executeIndex.find(function (ele) { return ele.indexId === data.id; });
            if (!!element) {
                element.num += data.changeValue;
                element.changeValue = data.changeValue;
            }
        },
        /**
         * 初始化核心指标
         * @param state
         * @param data
         */
        setKernelIndex: function (state, data) {
            state.kernelIndex = data;
        },
        /**
         * 更新核心资源单个值
         * @param state
         * @param data
         */
        pulKernelIndexItem: function (state, data) {
            if (data.name) {
                var dataBase = state.kernelIndex[data.name];
                dataBase.num -= data.changeValue;
                dataBase.changeValue = 0 - data.changeValue;
            }
            var elementArray = Object.values(state.kernelIndex);
            var element = elementArray.find(function (ele) { return ele.indexId === data.id; });
            if (!!element) {
                var elementKeysArray = Object.keys(state.kernelIndex);
                var keyIndex = elementArray.indexOf(element);
                var dataBase = state.kernelIndex[elementKeysArray[keyIndex]];
                // 判断
                if (data.value === 0 || !data.value) {
                    dataBase.num += data.changeValue;
                }
                else {
                    dataBase.num = data.value;
                }
                dataBase.num = Number(dataBase.num.toFixed(2));
                dataBase.changeValue = data.changeValue;
            }
        },
        /**
         * 查询所需更新的资源
         * @param state
         * @param data
         */
        pulSingleIndexItem: function (state, data) {
            var kernelItemArray = Object.values(state.kernelIndex);
            var kernelItem = kernelItemArray.find(function (ele) { return ele.indexId === data.id; });
            if (!!kernelItem) {
                this.commit('pulKernelIndexItem', data);
            }
            else {
                this.commit('pulExecuteIndexItem', data);
            }
        },
        /**
         * 后台获取剩余时间
         * @param state
         * @param data
         */
        setResidueTime: function (state, data) {
            var h = Math.floor(data / 3600);
            var min = Math.floor((data - (h * 3600)) / 60);
            var sec = data - h * 3600 - min * 60;
            state.residueTime = [h, min, sec];
        },
        /**
         * 更改判断事件弹框的判断值
         * @param state
         * @param data
         */
        changeJudgmentState: function (state, data) {
            var keys = Object.keys(state.judgment);
            if (!!keys.find(function (ele) { return ele === data.key; })) {
                state.judgment[data.key] = data.value;
            }
        },
        /**
         * 设置ws传入的事件数据
         * @param state
         * @param data
         */
        setIncedentState: function (state, data) {
            if (data.describeResult) {
                var dataBase = data.describeResult;
                dataBase.forEach(function (ele) {
                    var item = state.targetImgNameList.find(function (item) { return item.name === ele.indexName; });
                    ele.path = initKernelIndexPath(ele.indexName);
                });
                this.commit('setIncedentMeasureData', data);
            }
            else if (data.operationResult) {
                var dataBase = data.operationResult;
                dataBase.forEach(function (ele) {
                    ele.optionDataList.forEach(function (e) {
                        var item = state.targetImgNameList.find(function (item) { return item.name === e.indexName; });
                        e.path = initKernelIndexPath(e.indexName);
                    });
                });
            }
            state.incedent = data;
        },
        /**
         * 格式化数据检测反馈模块所需数据
         * @param state
         * @param data
         */
        setFeedback: function (state, data) {
            var _a;
            (_a = state.feedback).push.apply(_a, data);
        },
        /**
         * 存储数据监控图表所需数据
         * @param state
         * @param data
         */
        setExecuteMeasureData: function (state, data) {
            state.executeMeasureData = data;
            this.commit('setMonitorMeasure', data);
        },
        /**
         * 格式化数据检测措施模块所需数据
         * @param state
         * @param data
         */
        setMonitorMeasure: function (state, data) {
            var content = data.startTime + "min\uFF5E" + data.endTime + "min\uFF0C" + data.nodeName + "\u63AA\u65BD";
            var item = { icon: data.measureIcon, content: content };
            state.monitorMeasure.unshift(item);
        },
        /**
         * 格式化数据监控中事件模块所需数据
         * @param state
         * @param data
         */
        setIncedentMeasureData: function (state, data) {
            var _a;
            var startString = data.startTime + "min\u65F6\uFF0C\u4E8B\u4EF6\u53D1\u751F\u3002" + (data.resultContent || data.incidentDescribe);
            var str = '';
            if (data.describeResult) {
                var length_1 = data.describeResult.length;
                (_a = data.describeResult) === null || _a === void 0 ? void 0 : _a.forEach(function (ele, index) {
                    str += ele.indexName + ("" + (ele.changeValue > 0 ? '增加' : '减少') + Math.abs(ele.changeValue).toString() + (ele.unit ? ele.unit : ''));
                    str += index === length_1 ? '。' : '，';
                });
            }
            else if (data.stuChooseOptionResult) {
                str += '您的选择是：' + data.operatingOptionName + '。';
                // if (!!ele.operatingOptionDatas) {
                //   middleString += '您的选择是：' + ele.operatingOptionDatas[0].content + '。'
                // }
                data.stuChooseOptionResult.forEach(function (ele) {
                    str += ele.indexName + ele.result + Math.abs(ele.changeValue) + ele.unit + '，';
                });
                str = str.substr(0, str.length - 1);
                str += '。';
            }
            state.incedentMeasureData.unshift(startString + str);
        },
        setEndState: function (state, data) {
            state.endState = data;
        },
        /**
         * 初始化数据监控折线图数据格式
         * @param state
         * @param data
         */
        initMeasure: function (state, data) {
            state.measure = data;
        },
        /**
         * 设置数据监控中传给图表的数据
         * @param state
         * @param data
         */
        setMeasure: function (state, data) {
            var _a, _b;
            var measure = state.measure.find(function (ele) { return ele.indexName === data.indexName || ele.indexId === data.indexId; });
            if (measure) {
                var item = measure.data[data.scale];
                if (!item) {
                    // 时间超过X轴最大刻度时
                    // Math.ceil(data.scale / 10) 向上取整获得等同当前后端返回的scale差
                    (_a = measure.data).push.apply(_a, addBehindEmptyXAxis(Math.ceil(data.scale / 10), measure.data.length));
                    item = measure.data[data.scale];
                }
                // 设置指定分钟数对应的值
                if (!item.yValue) {
                    item.data = [data.measure.data[0]];
                }
                else {
                    item.data.forEach(function (ele) {
                        ele.coord[1] = data.measure.yValue;
                    });
                    item.data.push(data.measure.data[0]);
                }
                item.yValue = data.measure.yValue;
                // 设置两点间的值
                if (data.scale > 1 && measure.data[data.scale - 1].yValue === undefined) {
                    for (var i = item.scale - 1; i >= 0; i--) {
                        var yValue = measure.data[i].yValue;
                        if (yValue !== undefined) {
                            (_b = measure.data).splice.apply(_b, __spreadArrays([i + 1, item.scale - i], addEmptyXAxis(item.scale - measure.data[i].scale, item.yValue, yValue, i)));
                            break;
                        }
                    }
                }
            }
        },
        initIncedentMeasureData: function (state, data) {
            state.incedentMeasureData = data;
        },
        initMonitorMeasure: function (state, data) {
            state.monitorMeasure = data;
        },
        initFeedback: function (state, data) {
            state.feedback = data;
        },
        setDepartmentFeedBack: function (state, data) {
            var _a;
            var department = state.departmentList.find(function (ele) { return ele.id === data.id; });
            if (!!department) {
                if (data.isRead === undefined) {
                    var list = [];
                    data.list[0].stuIndexRecordList = data.list[0].stuIndexRecordList.filter(function (ele) {
                        ele.path = initKernelIndexPath(ele.indexName);
                        ele.changeValue = !!ele.changeValue ? fixedValue(ele.changeValue) : ele.changeValue;
                        ele.resultValue = !!ele.resultValue ? fixedValue(ele.resultValue) : ele.resultValue;
                        // list.push(state.executeIndex.find(ele2 => ele2.name === ele.indexName) || Object.values(state.kernelIndex).find(ele2 => ele2.name === ele.indexName))
                        return state.executeIndex.find(function (ele2) { return ele2.name === ele.indexName; }) || Object.values(state.kernelIndex).find(function (ele2) { return ele2.name === ele.indexName; });
                    });
                    // Object.values(state.kernelIndex)
                    if (!!department.stuMeasureRecordList) {
                        (_a = department.stuMeasureRecordList).push.apply(_a, data.list);
                    }
                    else {
                        department.stuMeasureRecordList = data.list;
                    }
                    department.read = false;
                }
                else {
                    department.stuMeasureRecordList.shift();
                    department.read = !(department.stuMeasureRecordList.length > 0);
                }
            }
        },
        initDepartmentFeedBack: function (state, data) {
            data.forEach(function (dep) {
                if (dep.stuMeasureRecordList) {
                    dep.stuMeasureRecordList.forEach(function (measure) {
                        measure.stuIndexRecordList.forEach(function (resource) {
                            resource.unit = !!resource.unit ? resource.unit : '';
                            resource.path = initKernelIndexPath(resource.indexName);
                            resource.changeValue = !!resource.changeValue ? fixedValue(resource.changeValue) : resource.changeValue;
                            resource.resultValue = !!resource.resultValue ? fixedValue(resource.resultValue) : resource.resultValue;
                        });
                    });
                }
            });
            state.departmentList = data;
        }
    },
    getters: {
        /**
         * 返回执行指标
         */
        executeIndex: function (state) {
            return state.executeIndex;
        },
        /**
         * 返回核心资源
         */
        kernelIndex: function (state) {
            return state.kernelIndex;
        },
        residueTime: function (state) {
            if (state.residueTime.length === 0) {
                return [0, 0, 0];
            }
            return state.residueTime;
        },
        judgment: function (state) {
            return state.judgment;
        },
        incedent: function (state) {
            return state.incedent;
        },
        feedback: function (state) {
            return state.feedback;
        },
        endState: function (state) {
            return state.endState;
        },
        monitorMeasure: function (state) {
            return state.monitorMeasure;
        },
        incedentMeasureData: function (state) {
            return state.incedentMeasureData;
        },
        measure: function (state) {
            return state.measure;
        },
        departmentList: function (state) {
            return state.departmentList;
        },
    },
    actions: {
        queryIndex: function (_a, id) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.queryIndex({
                    intelligentExperimentId: id
                }).then(function (res) {
                    var obj = __assign({}, res.data.data.filter(function (value) {
                        return value.indexType === "kernelIndex";
                    }));
                    var k = {};
                    for (var key in obj) {
                        if (obj.hasOwnProperty(key)) {
                            var element = obj[key];
                            var name = '';
                            switch (element.name) {
                                case '权威资源':
                                    name = "AuthoritativeResources";
                                    break;
                                case '财政资源':
                                    name = "FinancialResources";
                                    break;
                                case '目标人群满意度':
                                    name = "Satisfaction";
                                    break;
                                default:
                                    break;
                            }
                            // 没有type则设置为单位>>个
                            if (!element.unit) {
                                element.unit = '个';
                            }
                            k[name] = element;
                        }
                    }
                    var ExecuteIndexItem = res.data.data.filter((function (value) {
                        return value.indexType === "executeIndex";
                    }));
                    commit("setExecuteIndex", ExecuteIndexItem);
                    commit("setKernelIndex", k);
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        queryVariableFormula: function (_a, data) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.queryVariableFormula(data).then(function (res) {
                    resolve(res.data.data);
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        queryMonitorIndex: function (_a, data) {
            var _this = this;
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.monitorIndex(data).then(function (res) {
                    if (!res.data.success)
                        reject(res.data.data);
                    var formatData = [{
                            indexName: '目标人群满意度',
                            indexId: _this.state.doCase.kernelIndex.Satisfaction.indexId,
                            data: []
                        }];
                    var executeIndex = _this.state.doCase.executeIndex; // 执行指标数组
                    var executeIndexLength = executeIndex.length;
                    for (var i = 0; i < executeIndexLength; i++) {
                        // 监测数据中加入执行指标对应数组对象
                        formatData.push({
                            indexName: executeIndex[i].name,
                            indexId: executeIndex[i].indexId,
                            data: []
                        });
                    }
                    var scale = res.data.data[1].scale; // 坐标轴间隙
                    res.data.data.forEach(function (ele1) {
                        // 遍历后端返回数据
                        var monitorIndices = ele1.monitorIndices;
                        if (!!monitorIndices) {
                            monitorIndices.forEach(function (ele2) {
                                var arr = formatData.find(function (ele3) { return ele3.indexId === ele2.indexId; });
                                ele2.finalValue = !!ele2.finalValue ? fixedValue(ele2.finalValue) : ele2.finalValue;
                                if (!!arr) {
                                    var data_1 = arr.data;
                                    var data2_1 = {
                                        scale: ele2.stuIndexRecordScale,
                                        yValue: ele2.finalValue,
                                        data: []
                                    };
                                    ele2.monitorNodes.forEach(function (ele3) {
                                        var data3 = {
                                            coord: [ele2.stuIndexRecordScale, ele2.finalValue],
                                            symbolSize: 10,
                                            name: ele3.nodeName + "\u63AA\u65BD" + (ele3.takeEffect ? '生效' : '执行'),
                                            symbol: ele3.takeEffect ? 'diamond' : 'circle'
                                        };
                                        if (ele3.takeEffect === undefined) {
                                            data3.symbol = 'triangle';
                                            data3.name = '事件发生';
                                        }
                                        data2_1.data.push(data3);
                                    });
                                    // 填充线段空值
                                    var scaleDifference = !!data_1[0] ? data2_1.scale - data_1[data_1.length - 1].scale : 0;
                                    if (scaleDifference > 1) {
                                        var startNum = data_1[data_1.length - 1].data[0].coord[1];
                                        var endNum = data2_1.data[0].coord[1];
                                        data_1.push.apply(data_1, addEmptyXAxis(scaleDifference, endNum, startNum, data_1[data_1.length - 1].scale));
                                    }
                                    data_1.push(data2_1);
                                }
                            });
                        }
                    });
                    // 添加初始空值
                    formatData.forEach(function (ele) {
                        var _a, _b, _c;
                        var len = ele.data.length;
                        if (len === 0) {
                            (_a = ele.data).unshift.apply(_a, addHeadEmptyXAxis(scale * 10));
                        }
                        else {
                            (_b = ele.data).unshift.apply(_b, addHeadEmptyXAxis(ele.data[0].scale));
                            len = ele.data.length;
                            if (scale * 10 > len - 1) {
                                (_c = ele.data).push.apply(_c, addBehindEmptyXAxis(scale, len));
                            }
                        }
                    });
                    commit('initMeasure', formatData);
                    resolve();
                }).catch(function (err) {
                    reject(err);
                });
            });
        },
        monitorMeasureRecord: function (_a, data) {
            var _this = this;
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.monitorMeasureRecord(data).then(function (res) {
                    if (!res.data.success)
                        reject(res.data.data);
                    var data = res.data.data;
                    if (data.monitorFeedbackRecords && data.monitorFeedbackRecords.length > 0) {
                        var feedBack_1 = [];
                        data.monitorFeedbackRecords.forEach(function (ele) {
                            feedBack_1.push.apply(feedBack_1, JSON.parse(ele.incidentExplain));
                        });
                        _this.commit('initFeedback', feedBack_1);
                    }
                    if (data.monitorIncidentRecords && data.monitorIncidentRecords.length > 0) {
                        var incedentLiat_1 = [];
                        var listName_1 = '';
                        data.monitorIncidentRecords.forEach(function (ele) {
                            if (ele.indexInfluences) {
                                listName_1 = 'indexInfluences';
                            }
                            else {
                                listName_1 = 'operatingOptionDatas';
                            }
                            var startSting = ele.startTime + "min\u65F6\uFF0C\u4E8B\u4EF6\u53D1\u751F\u3002";
                            // let len: number = ele.incidentDescribe.length
                            var middleString = ele.incidentDescribe;
                            if (!!ele.operatingOptionDatas) {
                                middleString += '您的选择是：' + ele.operatingOptionDatas[0].content + '。';
                            }
                            var endString = '使得';
                            ele[listName_1].forEach(function (ele2) {
                                ele2.unit = !!ele2.unit ? ele2.unit : '个';
                                endString += ele2.indexName + ele2.result + ele2.num + ele2.unit + '，';
                            });
                            endString = endString.substr(0, endString.length - 1);
                            endString += '。';
                            incedentLiat_1.push(startSting + middleString + endString);
                            _this.commit('initIncedentMeasureData', incedentLiat_1);
                        });
                    }
                    if (data.monitorMeasureRecords && data.monitorMeasureRecords.length > 0) {
                        var list_1 = [];
                        data.monitorMeasureRecords.forEach(function (ele) {
                            list_1.push({
                                icon: ele.measureIcon,
                                content: ele.startTime + "min\uFF5E" + ele.endTime + "min\uFF0C" + ele.measureName + "\u63AA\u65BD"
                            });
                        });
                        _this.commit('initMonitorMeasure', list_1);
                    }
                    resolve();
                });
            });
        },
        batchRead: function (_a, data) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                http.batchRead([data.mId]).then(function (res) {
                    if (!res.data.success)
                        reject();
                    commit('setDepartmentFeedBack', { id: data.dId, list: data.list, isRead: data.isRead });
                    resolve();
                });
            });
        }
    }
};
/**
 * 小数保留2位小数
 * @param value
 */
function fixedValue(value) {
    var str = value.toString();
    // return str.split('.')[1] && str.split('.')[1].length > 2 && Number(value.toFixed(2)) || value
    return Number.parseFloat(value.toFixed(2));
}
/**
 * 初始化核心指标图片
 * @param name
 */
function initKernelIndexPath(name) {
    var _a;
    var pathList = [
        { name: '权威资源', path: require('../assets/img/student/bottle.png') },
        { name: '财政资源', path: require('../assets/img/student/possession.png') },
        { name: '目标人群满意度', path: require('../assets/img/student/laugh.png') },
    ];
    return (_a = pathList.find(function (ele) { return ele.name === name; })) === null || _a === void 0 ? void 0 : _a.path;
}
/**
 * 监测数据初始化时填充坐标轴间空值
 * @param scaleDifference X轴上两点的差值
 * @param endNum
 * @param startNum
 * @param scale 初始值X轴坐标
 */
function addEmptyXAxis(scaleDifference, endNum, startNum, scale) {
    var valueDifference = endNum - startNum;
    var slope = valueDifference / scaleDifference;
    var arr = [];
    for (var i = 1; i < scaleDifference; i++) {
        arr.push({
            scale: scale + i,
            yValue: startNum + slope,
            data: [{
                    symbolSize: 10,
                    coord: [scale + i, startNum + slope]
                }]
        });
    }
    return arr;
}
/**
 * 添加尾部空值坐标轴
 * @param scale 后端传入坐标轴差
 * @param count 当前数据个数
 */
function addBehindEmptyXAxis(scale, count) {
    var arr = [];
    for (var i = scale * 10 - 1; i >= count; i--) {
        arr.unshift({
            scale: i,
            data: [{
                    coord: [i],
                    symbolSize: 10
                }]
        });
    }
    return arr;
}
/**
 * 从头部添加空值坐标轴
 * @param count 需要添加的个数
 */
function addHeadEmptyXAxis(count) {
    var arr = [];
    for (var i = count - 1; i >= 0; i--) {
        arr.unshift({
            scale: i,
            data: [{ coord: [i], symbolSize: 10 }]
        });
    }
    return arr;
}
